/* Movatic WMS — Frontend | CesarFilho 932048016 */
import { useState } from 'react'

export default function StepWizard({
  steps, onFinish, title,
}: {
  title: string
  steps: { title: string, content: React.ReactNode }[]
  onFinish?: () => void
}) {
  const [idx, setIdx] = useState(0)
  const isLast = idx === steps.length - 1

  return (
    <div className="card p-4">
      <h2 className="text-lg font-semibold">{title}</h2>

      <div className="mt-4 flex items-center gap-2 text-sm">
        {steps.map((s, i) => (
          <div key={i} className={'px-3 py-1 rounded-full border ' + (i===idx ? 'bg-blue-600 text-white border-blue-600' : 'border-neutral-300 dark:border-neutral-700')}>
            {i+1}. {s.title}
          </div>
        ))}
      </div>

      <div className="mt-4">{steps[idx].content}</div>

      <div className="mt-4 flex items-center justify-between">
        <button className="navlink" onClick={() => setIdx(Math.max(0, idx-1))} disabled={idx===0}>Voltar</button>
        <button className="btn" onClick={() => {
          if (isLast) { onFinish?.() } else { setIdx(idx+1) }
        }}>{isLast ? 'Concluir' : 'Avançar'}</button>
      </div>
    </div>
  )
}
